import React, { useState } from 'react';
import { useLocation, Redirect } from 'react-router-dom';
import { Link as TUILink } from 'theme-ui';
import { useAuth } from '../../hooks/use-auth';
import useForm from '../../hooks/use-form';
import { Box, Button, Input, Link, Loading, Logo, Text } from '../../ui';
import API from '../../utils/api';

const Login = () => {
  let location = useLocation();
  const auth = useAuth();
  const { handleChange, handleSubmit, values } = useForm<{
    email: string;
    password: string;
  }>(login, {
    email: '',
    password: '',
  });
  const [error, setError] = useState();

  // Find out where the user is coming from
  // The page they were redirected here from
  let { from } = location.state || { from: { pathname: '/resumes' } };

  // Show loading spinner until we know if the users is authenticated.
  // This avoids flashing the login screen then redirecting to the app.
  if (auth.user === null) {
    return <Loading />;
  }

  // It's possible that a user is redirected here from an authenticated page
  // before the auth setup. If the auth realizes that they are logged in while
  // on this page, send them to where they came from.
  if (auth.user && !auth.user.isAnonymous) {
    return <Redirect to={from} />;
  }

  // If the user is logged in annonymously, log out and reload the page to
  // assure that the app state is clean before trying to log in
  if (auth.user && auth.user.isAnonymous) {
    API.auth.signOut({ userId: auth.user.uid });
  }

  function login() {
    API.auth
      .signIn({
        email: values.email,
        password: values.password,
      })
      .catch((error) => {
        setError(error.message);
      });
  }

  return (
    <Box
      variant="flex.center"
      sx={{
        backgroundColor: 'surfaceGray',
        width: '100vw',
        height: '100vh',
      }}
    >
      <Box sx={{ position: 'fixed', top: 16, left: 16 }}>
        <TUILink href={process.env.PUBLIC_WEBSITE_URL}>
          <Logo />
        </TUILink>
      </Box>
      <Box sx={{ width: 360 }}>
        <form onSubmit={handleSubmit}>
          <Text variant="title" mb={3}>
            Welcome.
          </Text>
          <Input
            placeholder="Email"
            type="email"
            value={values.email}
            name="email"
            onChange={handleChange}
            autoFocus
          />
          <Input
            placeholder="Password"
            type="password"
            value={values.password}
            name="password"
            onChange={handleChange}
          />
          {error && <Box id="gi-login-error-message">{error}</Box>}
          <Button mt={3} type="submit">
            Sign In
          </Button>

          <Link
            to={{ pathname: '/forgot', state: { email: values.email } }}
            sx={{ mt: 5, display: 'block' }}
          >
            Forgot password
          </Link>
          <TUILink
            href="/v2/setup"
            sx={{
              mt: 3,
              display: 'block',
              color: 'blue',
              textDecoration: 'none',
              fontWeight: 'bold',
            }}
          >
            Sign up
          </TUILink>
        </form>
      </Box>
    </Box>
  );
};

export default Login;
